import Vue from 'vue'
import App from './app/App.vue'
import router from './app/router'
import vSelect from 'vue-select'
import Vuelidate from 'vuelidate'
import { ModalAuthPlugin, ModalRejectConfirmPlugin, ModalNotifyPlugin } from "./plugins"
import store from './store/Store'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import './directives';

Vue.config.productionTip = false;
Vue.component('v-select', vSelect);
Vue.use(Vuelidate);
Vue.use(ModalAuthPlugin);
Vue.use(ModalRejectConfirmPlugin);
Vue.use(ModalNotifyPlugin);
Vue.use(Loading);

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
